export type UserClaimType = string | string[] | number | any;

// All the user's claims
export type UserClaims = {
  [key: string]: UserClaimType;
  userUid?: string;
};

export interface IGoogleDriveConfig {
  folderId: string;
  folderName: string;
  connectedAt: number;
  email?: string;
}

// Matches loosely to functions\node_modules\firebase-admin\lib\auth\user-record.d.ts
export type IAppUser = AppUser;

export type AppUser = {
  userId: string;
  authUid?: string;
  displayName: any;
  email: string;
  config?: string;
  userType?: "user" | "serviceaccount";
  allContactsGroupId?: string;
  terminated?: boolean;
  active?: boolean;
  disabled?: boolean;
  deactivated?: number;
  /** Foreign key pointing to media.id for user profile picture */
  photoMediaId?: string;
  storageQuota?: number;
  authProvider?: "password" | "google" | string;
  providerIds?: string[];
  lastSignInTime?: number;
  storageProvider?: "firebase" | "google_drive";
  googleDriveConfig?: IGoogleDriveConfig;
  betaGroup?: string;
};

export type AppUserModel = AppUser & {
  photoUrl?: string;
  photoIconUrl?: string;
  claims?: UserClaims;
  createdAt?: number;
  lastSignInTime?: number;
  authProvider?: "password" | "google" | string;
  providerIds?: string[];
  storageProvider?: "firebase" | "google_drive";
  googleDriveConfig?: IGoogleDriveConfig;
};

export type CreateAppUser = {
  displayName: any;
  email: string;
  password: string;
  claims: UserClaims[];
};

export type SendCustomVerificationEmailRequest = {
  domain: string;
};

export interface IMagicLink {
  id: string;
  email: string;
  linkType: "invitation" | "password_reset";
  createdAt: number;
  expiresAt: number;
  used: boolean;
  displayName?: string;
  contactId?: string;
  ownerId?: string;
}

export type MagicLink = IMagicLink;


export type SendForgotPasswordEmailRequest = {
  email: string;
  domain?: string;
};

export type SendForgotPasswordEmailResponse = {
  status: boolean;
  timestamp: number;
  error?: string;
  message?: string;
};

export type GetMagicLinksResponse = {
  status: boolean;
  timestamp: number;
  magicLinks?: MagicLink[];
  error?: string;
};

/**
 * Request payload for user account termination under Right of Deletion.
 */
export interface ITerminateAccountRequest {
  confirmationText: string;
}

/**
 * Response payload for user account termination.
 */
export interface ITerminateAccountResponse {
  status: boolean;
  timestamp: number;
  message?: string;
  error?: string;
}

/**
 * Request payload for updating user profile picture and small icon.
 */
export interface IUpdateProfilePictureRequest {
  photoBase64?: string; // 200x200 image
  iconBase64?: string;  // 50x50 icon
  contentType?: string;
  mediaId?: string;     // Existing Media ID to assign as profile picture
}

/**
 * Response payload for updating user profile picture and small icon.
 */
export interface IUpdateProfilePictureResponse {
  status: boolean;
  timestamp: number;
  photoUrl?: string;
  photoIconUrl?: string;
  photoMediaId?: string;
  error?: string;
}

